export interface QueryParam {
  fields?: string;
  filter: string;
  orderBy?: string;
  order?: 'ASC' | 'DESC';
  groupBy?: string;
  take?: number;
  skip?: number;
  continuationToken?: string;
}

export const queryParam: QueryParam = {
  filter: "",
};

export const buildQueryString = (params: Record<string, any>): string => {
    try {
        return Object.entries(params)
            .filter(([_, value]) => value !== undefined && value !== "")
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join("&");
    } catch (error) {
        console.error("Error building query string:", error);
        return "";
    }
};
  